/**
 * The ONLY reader of the noun dictionary from a component. `coreLabels` is never imported
 * by a component directly; labels merge once per enabled set.
 */
import { useMemo } from "react";

import { coreLabels, mergeLabels, type Labels } from "../domain/labels";
import { useEnabledModules } from "./useEnabledModules";

export function useLabels(): Labels {
  const enabled = useEnabledModules();
  return useMemo(
    () =>
      mergeLabels(
        coreLabels,
        enabled.map((m) => m.labels ?? {}),
      ),
    [enabled],
  );
}
